import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { productListInterface } from './product-list';

export type SortColumn = keyof productListInterface | '';
export type SortDirection = 'asc' | 'desc' | '';

const rotate: {[key: string]: SortDirection} = { 'asc': 'desc', 'desc': '', '': 'asc' };

export interface SortEvent {
    column: SortColumn;
    direction: SortDirection;
}

@Directive({
    selector: 'th[product]',
    standalone: true,
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '(click)': 'rotate()'
    },

})
export class ProductListDirective {

    constructor() { }

    @Input() product: SortColumn = '';
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.product, direction: this.direction });
    }

}
